import { useCallback } from "react";
import useWorkspaceApiCall from "hooks/useWorkspaceApiCall";
import { patchWorkspaceMfa } from "api/services/workspace-service";

export const usePatchWorkspaceMfa = () => {
    const { callAPI, loading } = useWorkspaceApiCall(patchWorkspaceMfa, 'mfaManagement.success', 'mfaManagement.error');

    const patchMfa = useCallback(async (mfaEnabled: boolean) => {
        return await callAPI({ mfaEnabled });
    }, [callAPI]);

    return { patchMfa, patching: loading };
};